// @flow
import React, { useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';

import Box from 'bizom-mui/lib/Box';

import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';

import { LocaleContext } from 'contexts/LocaleContext';
import { getSupportedLocalesByApp } from 'constants/languages';
import { MORE, CHANGE_LANGUAGE } from 'constants/strings';

const LOCALES = getSupportedLocalesByApp();

const styles = ({ palette, spacing }) => ({
  root: {
    padding: spacing(0, 1),
  },
  chip: {
    marginLeft: spacing(1),
  },
});

type Props = {
  classes: Object,
};

const LanguageSelector = ({ classes }: Props) => {
  const { language, setLocale, openDialoag } = useContext(LocaleContext);

  if(LOCALES.length === 1)
    return null;

  return (
    <Box px={1}>
      <Typography
        gutterBottom
        variant="caption"
        display="block"
        align="center"
        color="textSecondary"
      >
        {CHANGE_LANGUAGE}
      </Typography>
      <Grid container justify="center" wrap="nowrap">
        <Grid item>
          <Chip
            disabled
            size="small"
            className={classes.chip}
            label={LOCALES.filter(([lo]) => lo === language)[0][1]}
          />

          {LOCALES.length > 1 && (
            <Chip
              size="small"
              variant="outlined"
              className={classes.chip}
              label={language !== 'en' ? LOCALES[0][1] : LOCALES[1][1]}
              onClick={() =>
                setLocale(language !== 'en' ? LOCALES[0][0] : LOCALES[1][0])
              }
            />
          )}

          {LOCALES.length > 2 && (
            <Chip
              size="small"
              label={MORE}
              variant="outlined"
              icon={<AddIcon />}
              className={classes.chip}
              onClick={() => openDialoag(true)}
            />
          )}

        </Grid>
      </Grid>
    </Box>
  );
};

export default withStyles(styles)(LanguageSelector);
